/** Prefer local logo; fall back to live CDN if missing. */
const logo =
  process.env.PUBLIC_URL + "/logo1.webp";

export default logo;
